<template>
  <div :class="`bg-white rounded-lg border ${!internalIsOpen && !isValid ? 'border-danger' : 'border-grayLightest'}  overflow-hidden mb-1`">
    <div :class="`flex justify-between items-center p-2 ${internalIsOpen ? 'pb-0' : ''}`">
      <div class="flex items-center gap-1 w-full p-1">
        <div class="flex items-center gap-1 cursor-pointer" @click="toggle">
          <i :class="!internalIsOpen ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" />
          <svg v-if="icon" :width="iconSize.w" :height="iconSize.h">
            <use :xlink:href="`#${icon}`"></use>
          </svg>
          <div class="font-semibold text-15px">{{ title }}</div>
        </div>
        <slot name="title-action"></slot>
      </div>

      <slot name="action"></slot>
    </div>
    <div v-show="internalIsOpen" class="p-2 pt-1">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    isValid: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: '',
    },
    iconSize: {
      type: Object,
      default: () => ({ w: 14, h: 16 }),
    },
  },
  data() {
    return {
      internalIsOpen: this.isOpen,
    }
  },
  watch: {
    isOpen(value) {
      this.internalIsOpen = value
    },
  },
  methods: {
    toggle() {
      this.internalIsOpen = !this.internalIsOpen
    },
  },
}
</script>
